module.exports = __webpack_public_path__ + "static/logo_aelpida-e4644a75ffb0de41275a805ee08c8889.png";